import { atom, map } from "nanostores";

import {
  PaginationParams,
  PaginationStore,
  PaginationStoreState,
} from "../types/pagination";

export const createPaginationStore = (
  defaultPageSize = 10,
): PaginationStore => {
  // Create the store with default values
  const $pagination = map<PaginationStoreState>({
    currentPage: 1,
    pageSize: defaultPageSize,
  });

  // Create a separate atom for params that's compatible with the API store
  const $paginationParams = atom<PaginationParams>({
    currentPage: 1,
    pageSize: defaultPageSize,
  });

  // Update params atom whenever pagination changes
  $pagination.listen((state) => {
    $paginationParams.set({
      currentPage: state.currentPage,
      pageSize: state.pageSize,
    });
  });

  // Actions to manage pagination
  const setPage = (page: number): void => {
    $pagination.setKey("currentPage", page);
  };

  const nextPage = (): void => {
    const { currentPage, totalPages } = $pagination.get();

    if (totalPages === undefined || currentPage < totalPages) {
      $pagination.setKey("currentPage", currentPage + 1);
    }
  };

  const prevPage = (): void => {
    const { currentPage } = $pagination.get();

    if (currentPage > 1) {
      $pagination.setKey("currentPage", currentPage - 1);
    }
  };

  return {
    $pagination,
    $paginationParams,
    nextPage,
    prevPage,
    setPage,
  };
};
